import router from '@/router'
import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'

// 创建 axios 实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '',
  timeout: 10000
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code === 200) return res.data || res

    // 登录失效
    if (res.code === 401) {
      Toast.fail('登录失效，请重新登录')

      localStorage.removeItem('token');
      window.location.href = '/';

      return Promise.reject(new Error('登录失效'))
    }

    Toast.fail(res.msg || '接口请求失败')
    return Promise.reject(new Error(res.msg || 'Error'))
  },
  error => {
    Toast.fail(error.message || '网络错误')
    return Promise.reject(error)
  }
)

// 登录接口示例
export const login = (username, password) => {
  return api.post('/client/login', { username, password })
}

// 新增：发送重置密码邮箱验证码
export const sendResetCodeByEmail = (studentNo, email) => {
  return api.post('/client/email/sendCode', { studentNo, email, biz: 'resetPwd' })
}

// 新增：邮箱验证码重置密码
export const resetPwdByEmail = ({ studentNo, email, code, newPwd }) => {
  return api.post('/client/student/resetPwdByEmail', { studentNo, email, code, newPwd })
}

// 新增：发送重置密码短信验证码
export const sendResetCode = (mobile) => {
  return api.post('/client/sms/sendCode', { mobile, biz: 'resetPwd' })
}

// 新增：短信验证码重置密码
export const resetPwdBySms = ({ mobile, smsCode, newPwd }) => {
  return api.post('/client/student/resetPwdBySms', { mobile, smsCode, newPwd })
}

export default api
